import { uniqueId } from 'lodash/fp';

import { generateAccountStatusId, generateGraphQueryTemplateId } from 'dashboard/lib/stubs/account';
import { AccountStatus } from 'dashboard/models/account-status';
import {
  AccountType,
  AccountTypeAttributes,
  AccountTypesFilterOption,
} from 'dashboard/models/account-type';
import { Identifier } from 'dashboard/models/identifier';
import { FieldSchema, FieldSchemaType } from 'lib/fields';
import { ApiModel } from 'lib/interfaces/api';
import { RelationSchema } from 'lib/relations';

export const generateAccountTypeId = () => uniqueId('acttp_');

interface CreateMockAccountTypeOptions {
  attributes?: Partial<AccountTypeAttributes>;
  id?: string;
  defaultAccountStatusId?: string;
  accountStatuses?: AccountStatus[];
  defaultGraphQueryTemplate?: string;
  fieldSchemas?: FieldSchema[];
  relationSchemas?: RelationSchema[];
  identifiers?: Identifier[];
}

export function createMockAccountType({
  attributes,
  id,
  defaultAccountStatusId,
  accountStatuses,
  defaultGraphQueryTemplate,
  fieldSchemas,
  relationSchemas,
  identifiers,
}: CreateMockAccountTypeOptions = {}): AccountType {
  return {
    id: id || generateAccountTypeId(),
    type: ApiModel.AccountType,
    attributes: {
      'created-at': '2019-09-20T05:30:12.000Z',
      'updated-at': '2019-09-20T08:30:12.000Z',
      name: 'User',
      'is-legacy-account-type': true,
      'field-schemas': fieldSchemas || [
        {
          key: 'name',
          label: 'Name',
          type: FieldSchemaType.Hash,
          config: {
            'item-schemas': [
              {
                key: 'first',
                label: 'First',
                type: FieldSchemaType.String,
                config: {},
              },
              {
                key: 'middle',
                label: 'Middle',
                type: FieldSchemaType.String,
                config: {},
              },
              {
                key: 'last',
                label: 'Last',
                type: FieldSchemaType.String,
                config: {},
              },
            ],
          },
        },
        {
          key: 'birthdate',
          label: 'Birthdate',
          type: FieldSchemaType.Date,
          config: {},
        },
        {
          key: 'email_address',
          label: 'Email Address',
          type: FieldSchemaType.String,
          config: {},
        },
      ],
      'relation-schemas': relationSchemas || [],
      identifiers: [
        {
          key: 'reference_id',
          config: {
            'case-sensitive': true,
            unique: true,
          },
          'display-name': 'Reference ID',
        },
        {
          key: 'email_address',
          config: {
            'case-sensitive': false,
            unique: true,
          },
        },
        ...(identifiers || []),
      ],
      ...attributes,
    },
    relationships: {
      'default-account-status': {
        data: {
          type: ApiModel.AccountStatus,
          id: defaultAccountStatusId || generateAccountStatusId(),
        },
      },
      'account-statuses': {
        data: (accountStatuses || []).map((accountStatus) => {
          return { type: ApiModel.AccountStatus, id: accountStatus.id };
        }),
      },
      'default-graph-query-template': {
        data: {
          type: ApiModel.GraphQueryTemplate,
          id: defaultGraphQueryTemplate || generateGraphQueryTemplateId(),
        },
      },
    },
  };
}

export function createMockAccountTypesFilterOption(
  attributes?: Partial<AccountTypesFilterOption>,
): AccountTypesFilterOption {
  return {
    id: generateAccountTypeId(),
    name: 'User',
    'is-legacy-account-type': true,
    'updated-at': '2019-09-20T08:30:12.000Z',
    'default-graph-query-template-id': undefined,
    ...attributes,
  };
}
